import Layout from '@/layout'
import ParentView from '@/components/ParentView'

const asyncSourceManagementRoutes =
{
  path: '/oa/sourceManagement',
  component: Layout,
  redirect: 'noredirect',
  name: '仪器设备管理',
  funcPerms: 'oa:eqpt',
  meta: {
    title: '仪器设备管理',
    icon: 'equipment',
    affix: false,
    noCache: true
  },
  children: [
    {
      path: 'equipmentArchives',
      component: () => import('@/views/oa/sourceManagement/equipmentArchives/index'),
      funcPerms: 'oa:eqpt:dossier:mgr',
      name: 'equipmentArchives',
      meta: {
        title: '设备档案',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'equipmentArchives/add',
      component: () => import('@/views/oa/sourceManagement/equipmentArchives/add'),
      funcPerms: 'oa:hr:manager:add',
      name: 'EquipmentArchivesAdd',
      hidden: true,
      meta: {
        title: '新增设备信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'equipmentArchives/edit',
      component: () => import('@/views/oa/sourceManagement/equipmentArchives/add'),
      funcPerms: 'oa:hr:manager:add',
      name: 'EquipmentArchivesEdit',
      hidden: true,
      meta: {
        title: '编辑设备信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'equipmentArchives/view',
      component: () => import('@/views/oa/sourceManagement/equipmentArchives/add'),
      funcPerms: 'oa:hr:manager:add',
      name: 'EquipmentArchivesView',
      hidden: true,
      meta: {
        title: '查看设备信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    // {
    //   path: '/personnelManagement/edit',
    //   component: () => import('@/views/oa/personnelManagement/add'),
    //   funcPerms: 'oa:hr:manager:edit',
    //   name: 'personnelManagementEdit',
    //   hidden: true,
    //   meta: {
    //     title: '编辑人员信息',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/personnelManagement/view',
    //   component: () => import('@/views/oa/personnelManagement/add'),
    //   funcPerms: 'oa:hr:manager:view',
    //   name: 'personnelManagementView',
    //   hidden: true,
    //   meta: {
    //     title: '查看人员信息',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // }
    {
      path: 'equipmentApplication',
      component: () => import('@/views/oa/sourceManagement/equipmentApplication/index'),
      funcPerms: 'oa:eqpt:apply',
      name: 'equipmentApplication',
      meta: {
        title: '设备申请',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'equipmentApplication/add',
      component: () => import('@/views/oa/sourceManagement/equipmentApplication/add'),
      funcPerms: 'oa:hr:manager:add',
      name: 'equipmentApplicationAdd',
      hidden: true,
      meta: {
        title: '申请',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'scrapApplication',
      component: () => import('@/views/oa/sourceManagement/scrapApplication/index'),
      funcPerms: 'oa:eqpt:applyDiscard',
      name: 'scrapApplication',
      meta: {
        title: '申请报废',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'scrapApplicationAdd',
      component: () => import('@/views/oa/sourceManagement/scrapApplication/add'),
      funcPerms: 'oa:hr:manager',
      name: 'ScrapApplicationAdd',
      hidden: true,
      meta: {
        title: '报废申请新增',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'equipmentMaintenance',
      component: () => import('@/views/oa/sourceManagement/equipmentService/equipmentMaintenance/index'),
      funcPerms: 'oa:eqpt:maintenance',
      name: 'equipmentMaintenance',
      meta: {
        title: '设备维护',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'equipmentMaintenance/add',
      component: () => import('@/views/oa/sourceManagement/equipmentService/equipmentMaintenance/add'),
      funcPerms: 'oa:hr:manager',
      name: 'EquipmentMaintenanceAdd',
      hidden: true,
      meta: {
        title: '新增设备维护信息',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'equipmentMaintenance/edit',
      component: () => import('@/views/oa/sourceManagement/equipmentService/equipmentMaintenance/add'),
      funcPerms: 'oa:hr:manager',
      name: 'equipmentMaintenanceEdit',
      hidden: true,
      meta: {
        title: '编辑设备维护信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'equipmentMaintenance/view',
      component: () => import('@/views/oa/sourceManagement/equipmentService/equipmentMaintenance/add'),
      funcPerms: 'oa:hr:manager',
      name: 'equipmentMaintenanceView',
      hidden: true,
      meta: {
        title: '查看设备维护信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'equipmentCalibration',
      component: () => import('@/views/oa/sourceManagement/equipmentService/equipmentCalibration/index'),
      funcPerms: 'oa:eqpt:verification',
      name: 'equipmentCalibration',
      meta: {
        title: '设备检定',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'equipmentCalibration/add',
      component: () => import('@/views/oa/sourceManagement/equipmentService/equipmentCalibration/add'),
      funcPerms: 'oa:hr:manager',
      name: 'EquipmentCalibrationAdd',
      hidden: true,
      meta: {
        title: '新增设备检定信息',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'equipmentCalibration/edit',
      component: () => import('@/views/oa/sourceManagement/equipmentService/equipmentCalibration/add'),
      funcPerms: 'oa:hr:manager',
      name: 'equipmentCalibrationEdit',
      hidden: true,
      meta: {
        title: '编辑设备检定信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'equipmentCalibration/view',
      component: () => import('@/views/oa/sourceManagement/equipmentService/equipmentCalibration/add'),
      funcPerms: 'oa:hr:manager',
      name: 'equipmentCalibrationView',
      hidden: true,
      meta: {
        title: '查看设备检定信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'equipmentCorrect',
      component: () => import('@/views/oa/sourceManagement/equipmentService/equipmentCorrect/index'),
      funcPerms: 'oa:eqpt:calibration',
      name: 'equipmentCorrect',
      meta: {
        title: '设备校准',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'equipmentCorrect/add',
      component: () => import('@/views/oa/sourceManagement/equipmentService/equipmentCorrect/add'),
      funcPerms: 'oa:hr:manager',
      name: 'EquipmentCorrectAdd',
      hidden: true,
      meta: {
        title: '新增设备校准信息',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'equipmentCorrect/edit',
      component: () => import('@/views/oa/sourceManagement/equipmentService/equipmentCorrect/add'),
      funcPerms: 'oa:hr:manager',
      name: 'equipmentCorrectEdit',
      hidden: true,
      meta: {
        title: '编辑设备校准信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'equipmentCorrect/view',
      component: () => import('@/views/oa/sourceManagement/equipmentService/equipmentCorrect/add'),
      funcPerms: 'oa:hr:manager',
      name: 'equipmentCorrectView',
      hidden: true,
      meta: {
        title: '查看设备校准信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'equipmentUpkeep',
      component: () => import('@/views/oa/sourceManagement/equipmentService/equipmentUpkeep/index'),
      funcPerms: 'oa:eqpt:repair',
      name: 'equipmentUpkeep',
      meta: {
        title: '设备维修',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'equipmentUpkeep/add',
      component: () => import('@/views/oa/sourceManagement/equipmentService/equipmentUpkeep/add'),
      funcPerms: 'oa:eqpt:repair',
      name: 'EquipmentUpkeepAdd',
      hidden: true,
      meta: {
        title: '新增设备维修信息',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'equipmentUpkeep/edit',
      component: () => import('@/views/oa/sourceManagement/equipmentService/equipmentUpkeep/add'),
      funcPerms: 'oa:eqpt:repair',
      name: 'equipmentUpkeepEdit',
      hidden: true,
      meta: {
        title: '编辑设备维修信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'equipmentUpkeep/view',
      component: () => import('@/views/oa/sourceManagement/equipmentService/equipmentUpkeep/add'),
      funcPerms: 'oa:eqpt:repair',
      name: 'equipmentUpkeepView',
      hidden: true,
      meta: {
        title: '查看设备维修信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    }
  ]
}

export default asyncSourceManagementRoutes
